import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthValidate } from './layouts/AuthValidate';
import { Dashboard } from './pages/Dashboard';
import { Login } from './pages/Login';
import React from 'react';
import {useSelector} from "react-redux";
import Employees from "./pages/Employees";
import Employee from "./pages/Employee";
import GenerateQuote from "./pages/GenerateQuote";
import TerminateContract from "./pages/TerminateContract";
import Payroll from "./pages/Payroll";
import {selectAdminUser} from "./app/adminUser/selectors";

export const Router = () => {
    const {isAuthenticated} = useSelector(selectAdminUser)

    return (
        <Routes>
            <Route>
                <Route
                    path="/login"
                    element={isAuthenticated ? <Navigate to={{ pathname: '/' }} /> : <Login />}
                />

                <Route element={<AuthValidate />}>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/employee/:id" element={<Employee />} />
                    <Route path="/employees" element={<Employees />} />
                    <Route path="/generate_quote/:id" element={<GenerateQuote/>} />
                    <Route path="/terminate_contract/:id" element={<TerminateContract/>} />
                    <Route path="/payroll/:id" element={<Payroll/>}/>
                </Route>
            </Route>
        </Routes>
    );
}
